"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const orderPaymentDetailState_1 = require("@/order/payment_detail/orderPaymentDetailState");
const react_i18next_1 = require("react-i18next");
const detect_utils_1 = require("@/common/detect_utils");
const material_ui_confirm_1 = require("material-ui-confirm");
const Button_1 = __importDefault(require("@mui/material/Button"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const functions_1 = require("@/order/payment_detail/functions");
function default_1({ isActiveAddress, addressData, setDeliverySettingData, fetchAddressList, closeDialog, }) {
    const unmountRef = (0, detect_utils_1.useUnmountRef)();
    const pendingRef = (0, react_1.useRef)(false);
    const [isPending, setIsPending] = (0, react_1.useState)(false);
    const disablePending = () => {
        pendingRef.current = false;
        if (!unmountRef.current) {
            setIsPending(false);
        }
    };
    const { id: addressId } = addressData;
    const data = { user_delivery_id: addressId };
    const [{ order_status_cd_id }, setPaymentDetail] = (0, recoil_1.useRecoilState)(orderPaymentDetailState_1.paymentDetailState);
    const isPaymentAwait = order_status_cd_id === 'ORDER_STATUS_01';
    const onSuccess = () => {
        if (isPaymentAwait)
            (0, functions_1.refetchPaymentDetail)({ setPaymentDetail });
        setDeliverySettingData(prev => (Object.assign(Object.assign({}, prev), { default_delivery: Object.assign(Object.assign({}, addressData), { user_delivery_id: addressId }) })));
        closeDialog();
    };
    const onError = (errorCode) => __awaiter(this, void 0, void 0, function* () {
        if (errorCode === 40013)
            yield fetchAddressList();
        if (errorCode === 40001 || errorCode === 40004 || errorCode === 40005 || errorCode === 40011) {
            closeDialog();
        }
    });
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const onSelectAddressClick = () => __awaiter(this, void 0, void 0, function* () {
        if (isActiveAddress)
            closeDialog();
        else {
            if (!pendingRef.current) {
                pendingRef.current = true;
                setIsPending(true);
                yield (0, functions_1.patchPaymentDetail)({
                    data,
                    confirm,
                    setPaymentDetail,
                    onSuccess,
                    onError,
                    onFinally: disablePending,
                });
            }
        }
    });
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ disabled: isPending, onClick: onSelectAddressClick, sx: {
            minWidth: '50px',
            height: '28px',
            p: '0 12px',
            borderRadius: '6px',
            color: 'var(--white)',
            bgcolor: 'var(--gray-80) !important',
        } }, { children: isPending ? ((0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 12, color: "inherit", thickness: 6 })) : ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: "caption1" }, { children: t('V-선택') }))) })));
}
exports.default = default_1;
